<template>
  <div class="home">
    <p>帳票作成・更新</p>
    <v-row>
      <v-col align="left"
        ><v-btn
          @click.once="ReportCopy"
          color="red white--text"
          :disabled="$route.params.report_id == null"
          >コピー</v-btn
        ></v-col
      >
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
    </v-row>
    <v-container cols="12">
      <div v-if="isLoading" align="center">
        <v-progress-circular
          :size="250"
          color="primary"
          indeterminate
          align="center"
        ></v-progress-circular>
      </div>
      <div v-else>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-autocomplete
                :items="selectbox0"
                outlined
                background-color="white"
                v-model="productForms.area[0]"
                label="選択肢A"
                no-data-text="候補が見つかりません"
                clearable
                hide-details="false"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-autocomplete
                :items="selectbox0"
                outlined
                background-color="white"
                v-model="productForms.area[0]"
                label="選択肢B"
                no-data-text="候補が見つかりません"
                clearable
                hide-details="false"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" sm="4" md="4" lg="4">
              <v-select
                :items="selectbox2"
                outlined
                background-color="white"
                v-model="productForms.area[0]"
                label="選択肢3"
                hide-details="false"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      valid: true,
      FormList: [],
      productForms: {
        pageID: 0,
        area: [[]],
        delete_area: [],
      },
      //
      isLoading: false,
      selectbox0: ["1"],
      selectbox1: ["1"],
      selectbox2: ["2"],
    };
  },
  async mounted() {
    //初期処理
    this.isLoading = true;
    //FormListの取得
    //ProductFormsの取得
    //
    this.isLoading = false;
  },
  computed: {},
  methods: {
    back() {
      this.$router.push({
        path: "/",
      });
    },
    //
  },
};
</script>
